/**
 * Advertencias de "Buena práctica" para las ubicaciones dentro de una zona.
 * Solo avisan: nunca bloquean guardar ni afectan el score ni el checklist.
 * No citan ninguna norma.
 *
 * Fase 1: productos incompatibles en el MISMO rack (cualquier nivel o
 * posición), con la función única de compatibilidad (src/lib/compatibilidad.ts),
 * solo el nivel "incompatible". Las reglas verticales son de la Fase 2.
 */
import { paresConConflicto } from './compatibilidad';
import { ProductLocation, productosDelRack } from './ubicaciones';

export interface ProductoConClases { id: string; name: string; sga_classes?: string[] | null }

export interface AdvertenciaRack {
  rackId: string;
  pares: { a: ProductoConClases; b: ProductoConClases }[];
}

export function advertenciasMismoRack(
  rackIds: string[],
  ubicaciones: ProductLocation[],
  productos: ProductoConClases[],
): AdvertenciaRack[] {
  const porId = new Map(productos.map(p => [p.id, p]));
  const resultado: AdvertenciaRack[] = [];
  for (const rackId of rackIds) {
    const enRack = productosDelRack(ubicaciones, rackId)
      .map(id => porId.get(id))
      .filter((p): p is ProductoConClases => !!p)
      .sort((x, y) => x.name.localeCompare(y.name, 'es'));
    const pares = paresConConflicto(enRack)
      .filter(par => par.nivel === 'incompatible')
      .map(({ a, b }) => ({ a, b }));
    if (pares.length) resultado.push({ rackId, pares });
  }
  return resultado;
}
